import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Delete from '@material-ui/icons/Delete';
import esLocale from "date-fns/locale/es";
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from 'moment';
import { FormControl, Grid, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';


const useStyles = makeStyles(() => ({
    formControl: {
      marginLeft: 25,
      marginRight: 40,
      minWidth: 150,
    },
}));


const DeleteConveniosButton = ({ idItem, futura, fechaInicioVigencia, modulos=false, deletePracticas }) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [fechaFin, setFechaFin] = React.useState(new Date());
    const [eliminacionPerm, setEliminacionPerm] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChangeSelect = (e) => {
        setEliminacionPerm(e.target.value);
    };

    return (
        <>
            <Button
                style={{ color: "red" }}
                startIcon={<Delete />}
                size={"large"}
                onClick={handleClickOpen}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Está a punto de eliminar esta práctica, ¿Está seguro?"}</DialogTitle>
                
                <Grid container spacing={1}>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="elimPerm">Eliminación permanente</InputLabel>
                        <Select
                            labelId="elimPermLabel"
                            id="elimPermSelect"
                            name="elimPerm"
                            value={eliminacionPerm}
                            onChange={handleChangeSelect}
                        >
                            <MenuItem key={false} value={false}>NO</MenuItem>
                            <MenuItem key={true} value={true}>SI</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                
                
                
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {
                            eliminacionPerm ? 
                            "ATENCION. Recuerde que la eliminación permanente borrará los registros. Esta acción NO ES REVERSIBLE."
                            :
                            (!futura
                                ?
                                "Una vez eliminada, la misma dejará de estar vigente a partir de la fecha que indique. Asi mismo, toda valorizacion del mismo tipo posterior a esta fecha, será eliminada"
                                :
                                "")
                        }

                    </DialogContentText>
                    {
                        (!futura && !modulos && !eliminacionPerm) &&
                        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                id="dialogFechaFin"
                                label="Fecha fin vigencia"
                                format="dd/MM/yyyy"
                                okLabel="Aceptar"
                                required={true}
                                // maxDate={new Date()} //maxDate
                                minDate={moment(fechaInicioVigencia)}
                                clearLabel="Limpiar"
                                cancelLabel="Cancelar"
                                value={fechaFin}
                                minDateMessage={`La fecha no debe ser anterior a la fecha mínima`}
                                onChange={(date) => {
                                    setFechaFin(date);
                                }}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={() => {
                        deletePracticas(idItem, fechaFin, eliminacionPerm)
                        handleClose()
                    }} color="primary" autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DeleteConveniosButton
